import { render, staticRenderFns } from "./add_note.vue?vue&type=template&id=0a9a8a3d"
import script from "./add_note.vue?vue&type=script&lang=js"
export * from "./add_note.vue?vue&type=script&lang=js"
import style0 from "./add_note.vue?vue&type=style&index=0&id=0a9a8a3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports